(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["giveaway-instagram"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-giveaway-instagram]');
  if (!link) return;
  const privacy = window.Shopify && window.Shopify.customerPrivacy;
  if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() && typeof window.gtag === 'function') {
    window.gtag('event', 'giveaway_instagram_click', {
      placement: link.dataset.giveawayInstagram,
      campaign: 'q35_giveaway',
      link_url: link.href
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-round-gallery-video"] && !Shopify.designMode) return;
  try {
    function initMegaRoundGallery(root) {
  root.querySelectorAll('[data-round-gallery]').forEach(frame => {
    if (frame.dataset.ready) return;
    frame.dataset.ready = 'true';
    const video = frame.querySelector('video');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false, userPaused = false, systemPause = false;
    const load = () => {
      if (!video.getAttribute('src')) video.src = video.dataset.source;
    };
    const pause = () => {
      if (!video.paused) { systemPause = true; video.pause(); }
    };
    const resume = () => {
      if (visible && !document.hidden && !userPaused && !reduced.matches && !navigator.connection?.saveData) {
        load();
        video.muted = true;
        video.play().catch(() => {});
      }
    };
    video.addEventListener('pause', () => {
      if (systemPause) systemPause = false;
      else userPaused = true;
    });
    video.addEventListener('play', () => { userPaused = false; });
    video.addEventListener('pointerdown', load);
    video.addEventListener('keydown', load);
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .5;
      if (visible) { load(); resume(); }
      else pause();
    }, { threshold: .5 });
    observer.observe(video);
    document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); else resume(); });
    reduced.addEventListener('change', event => { if (event.matches) pause(); else resume(); });
  });
}
initMegaRoundGallery(document);
document.addEventListener('shopify:section:load', event => initMegaRoundGallery(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zentron-series-selector"] && !Shopify.designMode) return;
  try {
    function openSeriesComparison() {
    if (window.location.hash === '#compare-models') {
      const comparison = document.getElementById('compare-models');
      if (comparison) {
        comparison.open = true;
        comparison.scrollIntoView({block:'start'});
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openSeriesComparison);
  else openSeriesComparison();
  window.addEventListener('hashchange', openSeriesComparison);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zentron-video-player"] && !Shopify.designMode) return;
  try {
    (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const states = new Map();
    const pause = (video) => {
      video.autoplay = false;
      if (!video.paused) video.pause();
    };
    const start = (video, state) => {
      if (!state.visible || state.userPaused || document.hidden || motion.matches) return;
      if (video.readyState < 1) {
        if (!state.loading) {
          state.loading = true;
          video.preload = 'metadata';
          video.load();
        }
        return;
      }
      if (!Number.isFinite(video.duration) || video.duration > 45) return;
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.play().catch(() => { video.autoplay = false; });
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        const state = states.get(video);
        if (!state) return;
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
        if (state.visible) start(video, state);
        else pause(video);
      });
    }, { threshold: [0, 0.35] }) : null;
    const initialize = (root) => {
      if (!observer) return;
      root.querySelectorAll('.zt-video-player video[data-zt-auto-loop]').forEach((video) => {
        if (states.has(video)) return;
        const state = { visible: false, userPaused: false, loading: false };
        states.set(video, state);
        video.addEventListener('loadedmetadata', () => start(video, state));
        video.addEventListener('pause', () => {
          if (state.visible && !document.hidden && !motion.matches && !video.ended) {
            state.userPaused = true;
          }
        });
        video.addEventListener('play', () => { state.userPaused = false; });
        observer.observe(video);
      });
    };
    const updateVisibility = () => {
      states.forEach((state, video) => {
        if (document.hidden || motion.matches) pause(video);
        else start(video, state);
      });
    };
    document.addEventListener('visibilitychange', updateVisibility);
    motion.addEventListener('change', updateVisibility);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('volumechange', (event) => {
      const current = event.target;
      if (!(current instanceof HTMLVideoElement) || current.muted || !current.closest('.zt-video-player')) return;
      document.querySelectorAll('.zt-video-player video').forEach((video) => {
        if (video !== current) video.pause();
      });
    }, true);
    initialize(document);
  })();
  } catch(e) { console.error(e); }
})();

})();
